var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-workflow-history-activity-comment"},[_vm._v(" "+_vm._s(_vm.items.displayName)+" "),_c('strong',[_vm._v("نوشت :")]),_c('div',{staticClass:"comment"},[_vm._v(_vm._s(_vm.items.comment))])])}
var staticRenderFns = []

export { render, staticRenderFns }